import {Injectable} from '@angular/core';
import {catchError, map, tap} from 'rxjs/operators';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {RestApi} from '../../auth/rest.api';
//import {MessageService} from './message.service';


@Injectable({
  providedIn: 'root'
})
export class FRServices {

  private studioUrl = "api/ExternalSystem/formsrecognizer";

  constructor(private _restApi: RestApi, /*private messageService: MessageService*/) {
  }



  updateConfiguration(frConfiguartion: IFormsRecognizer, frGuid: string): Observable<any> {
    return this._restApi.post(this.studioUrl+ '/'+frGuid, frConfiguartion)
      .pipe(
        catchError(this.handleError<any>('updateFormsRecognizer', {success: 'false'}))
      );
  }

  getConfigurations(): Observable<any> {
    return this._restApi.get(this.studioUrl)
      .pipe(
        catchError(this.handleError<IFormsRecognizer>('getFormsRecognizer', null))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      //console.error(error); // log to console instead
      // this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      //this.messageService.showError(error.message)
      return of(result as T);
    };
  }

  private log(message: string) {
    // this.messageService.add(`SapService: ${message}`);
  }
}
